import { Dialog, styled as muiStyled } from '@mui/material'

export const IdlePopupaStyledDialog = muiStyled(Dialog)(
  ({ theme }) => ({
    '& .MuiDialog-paper': {
      borderRadius: '16px',
      overflow: 'hidden',
      maxWidth: '500px',
      width: '100%',
      maxHeight: '90vh',
      display: 'flex',
      flexDirection: 'column',
      boxShadow: '0 24px 64px rgba(0, 0, 0, 0.12), 0 8px 16px rgba(0, 0, 0, 0.08)',
      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif",
      [theme.breakpoints.down('sm')]: {
        maxWidth: 'calc(100% - 16px)',
        maxHeight: '95vh',
      },
    },
    '& .MuiDialog-container': {
      overflowY: 'auto',
    },
    // Removed backdropFilter to prevent blur issues on mobile
  }),
)
